import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Sparkles, Target, Lightbulb } from "lucide-react";

export const Mission = () => {
  return (
    <section className="py-10 bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Main Mission Statement */}
          <Card className="border-2 border-primary/30 p-6 md:p-8 mb-6 text-center bg-background/80 backdrop-blur-sm">
            <div className="inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-xl mb-3">
              <Sparkles className="w-5 h-5 text-white" />
            </div>

            <h2 className="text-2xl md:text-3xl font-display font-extrabold mb-2">
              More Than a Game
            </h2>

            <p className="text-lg md:text-xl font-bold text-primary mb-3">
              It's a Movement
            </p>

            <p className="text-sm md:text-base font-bold text-muted-foreground max-w-2xl mx-auto leading-7">
              Call It Out empowers young people to recognize, challenge, and transform bullying behavior.
              By fostering empathy, critical thinking, and courage, this game opens the door to meaningful
              conversations and real change.
            </p>
          </Card>

          {/* Values Grid */}
          <div className="grid md:grid-cols-2 gap-5 mb-7">
            <Card className="p-5 border-2 hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-5 h-5 text-primary" />
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-2">Our Goal</h3>
                  <p className="text-sm text-muted-foreground font-bold leading-6">
                    Create safer, more connected school communities where every student feels valued,
                    heard, and empowered to stand up against bullying.
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-5 border-2 hover:shadow-lg transition-all duration-300">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Lightbulb className="w-5 h-5 text-secondary" />
                </div>

                <div>
                  <h3 className="text-xl font-bold mb-2">Our Approach</h3>
                  <p className="text-sm text-muted-foreground font-bold leading-6">
                    Through authentic dialogue and shared experiences, students build the empathy and
                    courage needed to flip the script on bullying culture.
                  </p>
                </div>
              </div>
            </Card>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-display font-extrabold mb-3">
              Ready to Join the Movement?
            </h3>

            <p className="text-sm md:text-base font-bold text-muted-foreground mb-5 max-w-xl mx-auto leading-7">
              Together, we can flip the script on bullying and create lasting positive change in schools everywhere.
            </p>

            <Button
              size="default"
              variant="outline"
              className="border-2 font-bold text-sm px-6 py-4 rounded-xl hover:bg-muted transition-all"
              onClick={() =>
                document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};